/**
 * List-Item for Checkbox/Radio/Select
 */
export default class ListItem {
    value = ""
    text = ""

    constructor(value, text) {
        this.value = value
        this.text = text
    }
}